window.onresize = function () {
  fnResize();
}
window.onload = function () {
  fnResize();
}
setTimeout(()=>{
  fnResize();
},1600)
function fnResize() {
  // document.documentElement.style.fontSize = num + 'px';
  document.documentElement.style.fontSize = '192px';
}
fnResize()